import React from "react";

import { useHref } from "~/hooks/useHref";
import { useSessionLoggedIn } from "~/hooks/useSession";

import { Redirect, Loading } from "@bared/ui";

/**
 * Only render the component if the customer is logged in.
 */
export function withAuthGuard<T extends {}>(
  WrappedComponent: React.ComponentType<T>,
) {
  const ComponentWithGuard = (props: T) => {
    const loggedIn = useSessionLoggedIn();
    const loginHref = useHref("/account/login");

    if ("undefined" === typeof loggedIn) {
      return <Loading />;
    }

    if (false === loggedIn) {
      return <Redirect href={loginHref} />;
    }

    return <WrappedComponent {...props} />;
  };

  return ComponentWithGuard;
}
